import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface ClickIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const ClickIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: ClickIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M21.0405 18.6059L18.7687 20.8776L18.6674 20.9893L15.1482 17.47L13.3024 20.8776L8.82993 8.73807L20.5435 13.2815L17.5619 15.1273L21.0405 18.6059Z"
                stroke={color}
                strokeWidth={2}
                strokeLinejoin="round"
            />
            <path
                d="M6.7959 13.1736L5.07309 14.8244M5.61547 9.84964H2.99817M6.49198 6.48742C6.03594 6.05886 4.6481 4.64985 4.6481 4.64985M9.84789 6.23416V2.89992M13.06 6.80823L14.7977 5.04983"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default ClickIcon
